const Loader = () => {
  return <div className="loader">
    <img alt="Loading" src="/assets/loading.svg"/>
   </div>;
};

export default Loader;